import type { AnyAction, Middleware } from 'redux';
import { reload } from '../../actions/backendCommon';
import { types as snoozeTypes } from '../../actions/backendSnooze';
import { INFINITY_SNOOZE_THRESHOLD, USER_EVENT_TYPE } from '../../../constants/backend';
import { logUserEvent } from '../../actions/backendEventLogger';
import { captureInfoMessage } from '../../../tracker/raven';
import { dispatchBackend } from '../../types/backend';

const snoozeTimer: Middleware = store => {
    const getState = store.getState as () => { snooze: { snoozeFor: number } };
    let countdown: ReturnType<typeof setInterval> | null = null;
    let reloadTimer: ReturnType<typeof setTimeout> | null = null;

    return next => action => {
        const typedAction = action as AnyAction;
        const { type, payload } = typedAction;
        const result = next(action);

        switch (type) {
            case snoozeTypes.SET_SNOOZE_TIMER_SUCCESS: {
                const { snoozeFor } = payload;

                // Clear all timers
                if (countdown) {
                    clearInterval(countdown);
                }
                if (reloadTimer) {
                    clearTimeout(reloadTimer);
                }

                // Note: snoozeTimer is in seconds
                const timer = snoozeFor * 1000;

                captureInfoMessage(`App deactivation for ${snoozeFor} seconds`);

                const onTimeout = () => {
                    dispatchBackend(store.dispatch, { type: '@bg/RESUME_TRAINER_ACTIVE' });
                    dispatchBackend(store.dispatch, reload({ isImmediate: true, reason: 'RESUME_TRAINER' }));
                    dispatchBackend(store.dispatch, logUserEvent(USER_EVENT_TYPE.APP_ACTIVATE));
                };

                reloadTimer = setTimeout(() => {
                    onTimeout();
                }, timer);

                if (snoozeFor > 0) {
                    dispatchBackend(store.dispatch, logUserEvent(USER_EVENT_TYPE.APP_DEACTIVATE));
                }

                if (snoozeFor > INFINITY_SNOOZE_THRESHOLD) {
                    break;
                }

                const onInterval = () => {
                    const stateSnoozeFor = getState().snooze.snoozeFor;
                    if (stateSnoozeFor <= 0) return;
                    dispatchBackend(store.dispatch, {
                        type: snoozeTypes.SNOOZE_COUNTDOWN,
                        payload: { snoozeFor: stateSnoozeFor }
                    });
                };

                countdown = setInterval(() => {
                    onInterval();
                }, 1000);

                break;
            }
            default:
        }

        return result;
    };
};

export default snoozeTimer;
